import styled from 'styled-components'

export const ErrorMessage = styled.span`
    font-size: 12px;
    color: #f44336;

`